<template>
	<div>
		<div class="nav_bar">
			<van-nav-bar
				title="工程详情"
				left-arrow
				@click-left="$router.go(-1)"
			/>
		</div>
		<div style="height: 56px;"></div>
		<van-cell-group style="margin-bottom: 15px;">
			<van-cell title="工程名称" :value="form.projectName" />
			<van-cell title="工程地址" :value="form.projectAddress" />
			<van-cell title="施工公司" :value="form.projectCompany" />
		</van-cell-group>
		
		
		<van-cell-group>
			<div class="form-upload">
				<div class="form-upload-head">
					<div class="form-upload-title">照片附件</div>
					<div class="form-upload-desc">可以上传工地照片、中标公告、协议合同等可证明工程真实存在的文件。</div>
				</div>
				<van-image
					style="margin-right: 10px; margin-bottom: 10px;"
					v-for="(item,index) in form.projectPics"
					@click="predivPic(form.projectPics,index)"
					width="80"
					height="80"
					:src="item"
				/>
				<div v-if="form.projectPics.length < 1 && !loading">未上传~</div>
			</div>
		</van-cell-group>
		<div style=" padding: 32px 16px 0 16px;">
		    <van-button round block type="danger"  @click="deleteProject">删除</van-button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'title_add',
		data() {
			return {
				form : {
					projectPics : []
				},
				projectPicFile : [],
				loading : false
			}
		},
		mounted(){
			this.getInfo();
		},
		methods: {
			getInfo(){
				this.$toast.loading({
					message: '加载中...',
					forbidClick: true,
					duration : 0
				});
				this.loading = true;
				this.$get('/gtb/home/getInvoiceProject.html', {id: this.$route.query.id}).then(res => {
					this.$toast.clear();
					this.loading = false;
					if (res.success) {
						const data = res.PO;
						this.form = {
							id : data.id,
							projectName : data.projectName,
							projectCompany : data.projectCompany,
							projectAddress :data.projectAddr,
							projectPics : data.projectPics
						}
						
						let picFile = [];
						for( let i = 0; i < data.projectPics.length; i++ ){
							picFile.push({
								url : data.projectPics[i],
								status : 'done'
							})
						}
						this.projectPicFile = picFile;
				
					}else{
						this.$dialog({
							title : '提示',
							message: res.msg,
						});
					}
				}).catch((res) => {
					this.$toast.clear();
					this.loading = false;
				});
			},
			//图片预览
			predivPic(urls, index) {
				this.$imagePreview({
					images : urls,
					startPosition : index
				})
			},
			deleteProject(){
				const self = this;
				this.$dialog.confirm({
					title: '提示',
					message: '确认删除此工程？',
					beforeClose(action, done){
						if(action == "confirm"){
							self.$get('/gtb/home/deleteYqbJabInvoiceProject.html',{id: self.form.id}).then(res=>{
								done(false)
								self.$dialog.alert({
									title : '提示',
									message: res.msg
								}).then(()=>{
									if( res.success ){
										self.$router.go(-1);
									}
								});  
							}).catch(res=>{
								done(false);
							});
						}else{
							done();
						}
					},
				});
			}
			
		},
		
	}
</script>
<style scoped>
	.form-upload{padding: 16px;}
	.form-upload-head{margin-bottom: 15px;}
	.form-upload-title{margin-bottom: 5px;}
	.form-upload-desc {font-size: 12px;color: #999;}
</style>
